import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { AdminTabWheelCardComponent } from '../admin-tab-wheel-card/admin-tab-wheel-card.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyStateComponent } from '../../../wheel/ui/empty-state/empty-state.component';

@Component({
  selector: 'wil-admin-tab-wheel',
  standalone: true,
  imports: [AdminTabWheelCardComponent, FormsModule, ReactiveFormsModule, EmptyStateComponent],
  templateUrl: './admin-tab-wheel.component.html',
  styleUrl: './admin-tab-wheel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTabWheelComponent {
  public readonly accountId = input.required<string | null>();
  public readonly wheels = input.required<WheelVersion[] | null>();

  @Output()
  public readonly createWheelClick = new EventEmitter<void>();
}
